__turbopack_context__.v({
  "blogSecRight": "BlogSecRight-module__AnEgLq__blogSecRight",
  "calendarIcon": "BlogSecRight-module__AnEgLq__calendarIcon",
  "dateFieldError": "BlogSecRight-module__AnEgLq__dateFieldError",
  "dateFieldWrap": "BlogSecRight-module__AnEgLq__dateFieldWrap",
  "dateInputWrap": "BlogSecRight-module__AnEgLq__dateInputWrap",
  "desktopShareText": "BlogSecRight-module__AnEgLq__desktopShareText",
  "enquiryForm": "BlogSecRight-module__AnEgLq__enquiryForm",
  "fieldError": "BlogSecRight-module__AnEgLq__fieldError",
  "formControl": "BlogSecRight-module__AnEgLq__formControl",
  "formControlSelect": "BlogSecRight-module__AnEgLq__formControlSelect",
  "formControlTextarea": "BlogSecRight-module__AnEgLq__formControlTextarea",
  "formField": "BlogSecRight-module__AnEgLq__formField",
  "formMainHeading": "BlogSecRight-module__AnEgLq__formMainHeading",
  "inputGroup": "BlogSecRight-module__AnEgLq__inputGroup",
  "inputGroupError": "BlogSecRight-module__AnEgLq__inputGroupError",
  "inputLegend": "BlogSecRight-module__AnEgLq__inputLegend",
  "mobileShareText": "BlogSecRight-module__AnEgLq__mobileShareText",
  "newsletterField": "BlogSecRight-module__AnEgLq__newsletterField",
  "newsletterForm": "BlogSecRight-module__AnEgLq__newsletterForm",
  "newsletterInput": "BlogSecRight-module__AnEgLq__newsletterInput",
  "newsletterInputError": "BlogSecRight-module__AnEgLq__newsletterInputError",
  "phoneField": "BlogSecRight-module__AnEgLq__phoneField",
  "phoneFieldLabel": "BlogSecRight-module__AnEgLq__phoneFieldLabel",
  "phoneFieldWrap": "BlogSecRight-module__AnEgLq__phoneFieldWrap",
  "recentCard": "BlogSecRight-module__AnEgLq__recentCard",
  "recentContent": "BlogSecRight-module__AnEgLq__recentContent",
  "recentImg": "BlogSecRight-module__AnEgLq__recentImg",
  "recentList": "BlogSecRight-module__AnEgLq__recentList",
  "recentMeta": "BlogSecRight-module__AnEgLq__recentMeta",
  "recentPostTitle": "BlogSecRight-module__AnEgLq__recentPostTitle",
  "sidebarBox": "BlogSecRight-module__AnEgLq__sidebarBox",
  "sidebarBox2": "BlogSecRight-module__AnEgLq__sidebarBox2",
  "sidebarTitle": "BlogSecRight-module__AnEgLq__sidebarTitle",
  "socialBtn": "BlogSecRight-module__AnEgLq__socialBtn",
  "socialRow": "BlogSecRight-module__AnEgLq__socialRow",
  "submitBtn": "BlogSecRight-module__AnEgLq__submitBtn",
  "subscribeBtn": "BlogSecRight-module__AnEgLq__subscribeBtn",
  "tagPill": "BlogSecRight-module__AnEgLq__tagPill",
  "tagsContainer": "BlogSecRight-module__AnEgLq__tagsContainer",
});
